import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { WebsocketCommandType } from 'src/app/shared/enums/websocket-command-type.enum';
import { WebsocketSignalRService } from 'src/app/shared/services/websocket-signalr.service';
import { ChatStateService } from './chat-state.service';

interface AiChatContentInfo {
  totalContentCount: number;
  unlockedContentCount: number;
  currentRating: number;

  contents: AiContent[];
}

export interface AiContent {
  index: number;
  ratingRequired: number;
  url: string;
  contentType: 'Image' | 'Video';
}

@Injectable({ providedIn: 'root' })
export class ChatContentService {
  public readonly contentInfo$ = new BehaviorSubject<AiChatContentInfo>(null);
  public readonly contentAdded$ = new Subject<AiContent[]>();

  private _currentContentCounter = -1;

  constructor(
    private _websocketSignalRService: WebsocketSignalRService,
    private _chatStateService: ChatStateService,
  ) {
    _chatStateService.aiChatContentInfo$.subscribe((chatContent) => {
      if (
        chatContent &&
        chatContent.unlockedContentCount > this._currentContentCounter &&
        !this._chatStateService.isCustomChat$.value
      ) {
        this._currentContentCounter = chatContent.unlockedContentCount;
        this.updateContentInfo(this._chatStateService.chatId);
      }
    });
  }

  public init(): void {
    this.contentInfo$.next(null);
    this._currentContentCounter = -1;
  }

  private updateContentInfo(chatId: string): void {
    this._websocketSignalRService
      .invoke<AiChatContentInfo>(WebsocketCommandType.getAiChatContentInfo, {
        chatId: chatId,
      })
      .subscribe((res) => {
        if (this.contentInfo$.value) {
          const newItems = res.contents.filter((newItem) => {
            const oldItem = this.contentInfo$.value.contents.find(
              (item) => item.index === newItem.index,
            );
            return oldItem && oldItem.url === null && newItem.url !== null;
          });

          this.contentAdded$.next(newItems);
        }

        this.contentInfo$.next(res);
      });
  }
}
